"use client";

import { MessageCircle, Phone, Mail, MessageSquare, ArrowRight, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DownloadOfficialCv() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const contactMethods = [{
    icon: Mail,
    label: "Inquiry",
    value: "casting@jordanrivers.com"
  }, {
    icon: Phone,
    label: "Agent",
    value: "GMT-5 Office Hours"
  }, {
    icon: MessageSquare,
    label: "Status",
    value: "Currently On Set"
  }];
  return <section data-section-id="772" id="download-official-cv" className="bg-background text-foreground relative overflow-hidden py-24 md:py-[120px] px-4 border-t border-border">
      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
        <Sparkles className="absolute top-[12%] left-[8%] size-6 text-primary/5" />
        <Sparkles className="absolute top-[22%] right-[12%] size-8 text-primary/10" />
        <Sparkles className="absolute top-[60%] left-[14%] size-5 text-primary/5" />
        <Sparkles className="absolute bottom-[18%] right-[10%] size-7 text-primary/8" />
        <Sparkles className="absolute bottom-[30%] left-[40%] size-4 text-primary/5" />
        <Sparkles className="absolute top-[45%] right-[30%] size-5 text-primary/5" />
        <Sparkles className="absolute bottom-[10%] left-[28%] size-6 text-primary/10" />
        <Sparkles className="absolute top-[8%] right-[40%] size-4 text-primary/5" />
      </div>

      <div ref={ref} className={`relative mx-auto max-w-[720px] text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div className="flex justify-center mb-8">
          <div className="relative">
            <div className="size-20 rounded-lg bg-secondary flex items-center justify-center border border-border">
              <MessageCircle className="size-9 text-primary" strokeWidth={1.25} />
            </div>
            <div className="absolute -top-1 -right-1 size-3 bg-primary" />
          </div>
        </div>

        {}
        <h2 className="font-default font-light text-foreground text-4xl md:text-5xl lg:text-[56px] leading-[1.0] mb-6 uppercase">
          Secure the <span className="italic text-foreground/40">Protagonist.</span>
        </h2>

        {}
        <p className="font-sans text-base md:text-lg text-foreground/70 leading-relaxed mb-10 max-w-xl mx-auto font-light">
          Access the complete visual archive, physical statistics, and professional 
          performance credits. Download the official casting resume and headshot below.
        </p>

        {}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg px-8 py-6 h-auto text-base font-medium shadow-md w-full sm:w-auto uppercase tracking-wider">
            <Link to="/RepresentationPage">
              Download Official CV
              <ArrowRight className="size-4 ml-1" />
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="border-border bg-transparent text-foreground hover:bg-secondary hover:text-foreground rounded-lg px-8 py-6 h-auto text-base font-medium w-full sm:w-auto uppercase tracking-wider">
            <Link to="/TheLedgerPage">
              <Phone className="size-4" />
              View Performance Credits
            </Link>
          </Button>
        </div>

        {}
        <div className="flex flex-col md:flex-row md:flex-wrap justify-center items-center gap-4 md:gap-8 pt-8 border-t border-border">
          {contactMethods.map((method, i) => {
          const Icon = method.icon;
          return <div key={i} data-index={i} className="flex items-center gap-2.5 text-sm">
                <Icon className="size-4 text-primary shrink-0" />
                <span className="font-mono text-foreground/90">
                  <span className="font-medium uppercase">{method.label}</span>
                  <span className="text-border mx-2">·</span>
                  <span className="text-muted-foreground">{method.value}</span>
                </span>
              </div>;
        })}
        </div>
      </div>
    </section>;
}